import React from 'react';

function GeneralMainSection({
  headerSentence,
  description,
  services,
  commitment,
  mainImage,
  mainImageAlt,
  imageTwo,
  imageThree,
}) {
  return (
    <section className='grid w-full'>
      <div className='grid lg:grid-cols-[3fr_1fr] gap-x-12 px-6 sm:px-8 md:px-12 lg:container lg:mx-auto lg:max-w-[60vw]'>
        {/* Text section */}
        <section className='grid gap-6'>
          {/* Header */}
          <section>
            <h2 className='text-3xl font-bold'>{headerSentence}</h2>
            <div className='h-[2px] bg-colour2 mt-2'></div>
          </section>

          {/* Description */}
          <section>
            <article className='text-lg text-gray-700'>{description}</article>
          </section>

          <div className='lg:hidden'>
            <img
              src={mainImage}
              alt={mainImageAlt}
              className='w-full h-auto rounded-lg shadow-md'
            />
          </div>

          {/* Services Section */}
          {services && services.length > 0 && (
            <section className='grid gap-4'>
              <h3 className='text-2xl font-semibold text-colour3'>
                Our Services Include:
              </h3>
              <ul className='grid gap-3 list-disc pl-5 text-gray-700'>
                {services.map((service, index) => (
                  <li key={index}>
                    <strong>{service.title}:</strong> {service.description}
                  </li>
                ))}
              </ul>
            </section>
          )}

          {/* Commitment Section */}
          {commitment && (
            <section>
              <p className='text-lg text-gray-700'>{commitment}</p>
            </section>
          )}
        </section>

        {/* Image section */}
        <section className='grid mt-6'>
          <div>
            <img
              src={imageThree}
              alt={mainImageAlt}
              className='w-full h-auto rounded-lg shadow-cardShadow'
            />
          </div>
          <div className='grid mt-6'>
            <img
              src={imageTwo}
              alt={mainImageAlt}
              className='w-full h-auto rounded-lg shadow-cardShadow'
            />
          </div>
          <div className='hidden lg:inline-block'>
            <img
              src={mainImage}
              alt={mainImageAlt}
              className='w-full h-auto rounded-lg shadow-cardShadow'
            />
          </div>
        </section>
      </div>
    </section>
  );
}

export default GeneralMainSection;
